import * as actionTypes from '../constants/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  serviceRequestStatusChangeError: null,
  serviceRequestStatusChangeLoading: false,

  serviceRequestPipelinesControlConfig: null,
  serviceRequestPipelinesControlConfigError: null,
  serviceRequestPipelinesControlConfigLoading: false,

  serviceRequestPipelinesStages: null,
  serviceRequestPipelinesStagesError: null,
  serviceRequestPipelinesStagesLoading: false,

  serviceRequestStageChange: null,
  serviceRequestStageChangeError: null,
  serviceRequestStageChangeLoading: false,

  saveServiceRequestPipelinesControlConfig: null,
  saveServiceRequestPipelinesControlConfigError: null,
  saveServiceRequestPipelinesControlConfigLoading: false,

  serviceRequestCustomTypeChange: null,
  serviceRequestCustomTypeChangeError: null,
  serviceRequestCustomTypeChangeLoading: false,

  serviceRequestPipelinesCustomTypes: null,
  serviceRequestPipelinesCustomTypesError: null,
  serviceRequestPipelinesCustomTypesLoading: false,
};

const changeServiceRequestStatusStart = (state, action) => {
  return updateObject(state, {
    serviceRequestStatusChangeError: null,
    serviceRequestStatusChangeLoading: true,
  });
};

const changeServiceRequestStatusSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestStatusChangeError: null,
    serviceRequestStatusChangeLoading: false,
  });
};

const changeServiceRequestStatusFail = (state, action) => {
  return updateObject(state, {
    serviceRequestStatusChangeError: action.error,
    serviceRequestStatusChangeLoading: false,
  });
};

const changeServiceRequestStageStart = (state, action) => {
  return updateObject(state, {
    serviceRequestStageChangeError: null,
    serviceRequestStageChangeLoading: true,
  });
};

const changeServiceRequestStageSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestStageChange: action.serviceRequestStageChange,
    serviceRequestStageChangeError: null,
    serviceRequestStageChangeLoading: false,
  });
};

const changeServiceRequestStageFail = (state, action) => {
  return updateObject(state, {
    serviceRequestStageChangeError: action.error,
    serviceRequestStageChangeLoading: false,
  });
};

const getServiceRequestPipelinesControlConfigStart = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesControlConfigError: null,
    serviceRequestPipelinesControlConfigLoading: true,
  });
};

const getServiceRequestPipelinesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesControlConfig: action.serviceRequestPipelinesControlConfig,
    serviceRequestPipelinesControlConfigError: null,
    serviceRequestPipelinesControlConfigLoading: false,
  });
};

const getServiceRequestPipelinesControlConfigFail = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesControlConfig: null,
    serviceRequestPipelinesControlConfigError: action.error,
    serviceRequestPipelinesControlConfigLoading: false,
  });
};

const getServiceRequestPipelinesStagesStart = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesStagesError: null,
    serviceRequestPipelinesStagesLoading: true,
  });
};

const getServiceRequestPipelinesStagesSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesStages: action.serviceRequestPipelinesStages,
    serviceRequestPipelinesStagesError: null,
    serviceRequestPipelinesStagesLoading: false,
  });
};

const getServiceRequestPipelinesStagesFail = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesStages: null,
    serviceRequestPipelinesStagesError: action.error,
    serviceRequestPipelinesStagesLoading: false,
  });
};

const saveServiceRequestPipelinesControlConfigStart = (state, action) => {
  return updateObject(state, {
    saveServiceRequestPipelinesControlConfigError: null,
    saveServiceRequestPipelinesControlConfigLoading: true,
  });
};

const saveServiceRequestPipelinesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    saveServiceRequestPipelinesControlConfig: action.saveServiceRequestPipelinesControlConfig,
    saveServiceRequestPipelinesControlConfigError: null,
    saveServiceRequestPipelinesControlConfigLoading: false,
  });
};

const saveServiceRequestPipelinesControlConfigFail = (state, action) => {
  return updateObject(state, {
    saveServiceRequestPipelinesControlConfigError: action.error,
    saveServiceRequestPipelinesControlConfigLoading: false,
  });
};


const changeServiceRequestCustomTypeStart = (state, action) => {
  return updateObject(state, {
    serviceRequestCustomTypeChangeError: null,
    serviceRequestCustomTypeChangeLoading: true,
  });
};

const changeServiceRequestCustomTypeSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestCustomTypeChange: action.serviceRequestCustomTypeChange,
    serviceRequestCustomTypeChangeError: null,
    serviceRequestCustomTypeChangeLoading: false,
  });
};

const changeServiceRequestCustomTypeFail = (state, action) => {
  return updateObject(state, {
    serviceRequestCustomTypeChangeError: action.error,
    serviceRequestCustomTypeChangeLoading: false,
  });
};

const getServiceRequestPipelinesCustomTypesStart = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesCustomTypesError: null,
    serviceRequestPipelinesCustomTypesLoading: true,
  });
};

const getServiceRequestPipelinesCustomTypesSuccess = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesCustomTypes: action.serviceRequestPipelinesCustomTypes,
    serviceRequestPipelinesCustomTypesError: null,
    serviceRequestPipelinesCustomTypesLoading: false,
  });
};

const getServiceRequestPipelinesCustomTypesFail = (state, action) => {
  return updateObject(state, {
    serviceRequestPipelinesCustomTypes: null,
    serviceRequestPipelinesCustomTypesError: action.error,
    serviceRequestPipelinesCustomTypesLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SERVICE_REQUEST_STATUS_START:
      return changeServiceRequestStatusStart(state, action);
    case actionTypes.CHANGE_SERVICE_REQUEST_STATUS_SUCCESS:
      return changeServiceRequestStatusSuccess(state, action);
    case actionTypes.CHANGE_SERVICE_REQUEST_STATUS_FAIL:
      return changeServiceRequestStatusFail(state, action);

    case actionTypes.GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START:
      return getServiceRequestPipelinesControlConfigStart(state, action);
    case actionTypes.GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS:
      return getServiceRequestPipelinesControlConfigSuccess(state, action);
    case actionTypes.GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL:
      return getServiceRequestPipelinesControlConfigFail(state, action);

    case actionTypes.GET_SERVICE_REQUESTS_STAGES_START:
      return getServiceRequestPipelinesStagesStart(state, action);
    case actionTypes.GET_SERVICE_REQUESTS_STAGES_SUCCESS:
      return getServiceRequestPipelinesStagesSuccess(state, action);
    case actionTypes.GET_SERVICE_REQUESTS_STAGES_FAIL:
      return getServiceRequestPipelinesStagesFail(state, action);

    case actionTypes.CHANGE_SERVICE_REQUEST_STAGE_START:
      return changeServiceRequestStageStart(state, action);
    case actionTypes.CHANGE_SERVICE_REQUEST_STAGE_SUCCESS:
      return changeServiceRequestStageSuccess(state, action);
    case actionTypes.CHANGE_SERVICE_REQUEST_STAGE_FAIL:
      return changeServiceRequestStageFail(state, action);

    case actionTypes.SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START:
      return saveServiceRequestPipelinesControlConfigStart(state, action);
    case actionTypes.SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS:
      return saveServiceRequestPipelinesControlConfigSuccess(state, action);
    case actionTypes.SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL:
      return saveServiceRequestPipelinesControlConfigFail(state, action);

    case actionTypes.CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_START:
      return changeServiceRequestCustomTypeStart(state, action);
    case actionTypes.CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_SUCCESS:
      return changeServiceRequestCustomTypeSuccess(state, action);
    case actionTypes.CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_FAIL:
      return changeServiceRequestCustomTypeFail(state, action);

    case actionTypes.GET_SERVICE_REQUESTS_CUSTOM_TYPES_START:
      return getServiceRequestPipelinesCustomTypesStart(state, action);
    case actionTypes.GET_SERVICE_REQUESTS_CUSTOM_TYPES_SUCCESS:
      return getServiceRequestPipelinesCustomTypesSuccess(state, action);
    case actionTypes.GET_SERVICE_REQUESTS_CUSTOM_TYPES_FAIL:
      return getServiceRequestPipelinesCustomTypesFail(state, action);
    default:
      return state;
  }
};

export default reducer;
